export const broadcaster = new BroadcastChannel('tab_channel');
export const messageReceiver = new BroadcastChannel('tab_channel');